import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './app-footer.html',
  styleUrls: ['./app-footer.css']
})
export class AppFooter {
  currentYear: number = new Date().getFullYear();

}
